import styled, { css } from "styled-components"
import media from "../utils/media"
import { Flex as Reflexbox, Box as PlainBox } from "reflexbox/styled-components"
import React from "react"

const fluid = css`
  padding: 0;
  width: 100% !important;
  max-width: 100% !important;
`

const shrink = css`
  ${media.fromPhone`width: 80%!important;`};
  ${media.fromDesktop`max-width: 1120px!important;`};
`

export const contain = css`
  margin: auto;
  width: 100%;
  padding: 0 26px;
  ${media.fromTablet`width: 90%;`};
  ${media.fromDesktop`max-width: 1280px;`};
`

const center = css`
  justify-content: center;
  align-items: center;
`
export const Flex = styled(props => <Reflexbox {...props} />)`
  margin: auto;
  flex-wrap: wrap;
  width: 100%;
  ${props => (props.center ? center : null)}
  ${media.fromTablet`width: 90%;`};
  ${media.fromDesktop`max-width: 1280px;`};
  ${props => (props.fluid ? fluid : "padding: 0 26px;")};
  ${props => (props.shrink ? shrink : null)}
`
export const Box = styled(
  React.forwardRef((props, ref) => {
    return <PlainBox ref={ref} {...props} />
  })
)`
  ${props => (props.flex ? "display: flex;" : null)}
`
